import { t } from "@lingui/macro";

export const AboutPage = () => (
  <main className="container py-24">
    <h1 className="text-4xl font-bold">{t`About`}</h1>
  </main>
);
